/* eslint-disable quotes */
import http from '../../../../../libs/http'
const api = `${process.env.VUE_APP_MICROSERVICE_API_AMORTIZATIONS}/all-permissions`
export default async () => {
  const { data } = await http.get(`${api}`)
  return data ?? []
}
